/**
 * @generated SignedSource<<0ddcfe331aaa0cb325813931075500d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmployeeCreateInput = {
  name: string;
};
export type UserAdminMainComponentEmployeeCreateMutation$variables = {
  input: EmployeeCreateInput;
  storeId?: string | null;
};
export type UserAdminMainComponentEmployeeCreateMutation$data = {
  readonly store: {
    readonly employeeCreate: {
      readonly employee: {
        readonly id: string;
      };
    } | null;
  };
};
export type UserAdminMainComponentEmployeeCreateMutation = {
  response: UserAdminMainComponentEmployeeCreateMutation$data;
  variables: UserAdminMainComponentEmployeeCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "EmployeeCreatePayload",
        "kind": "LinkedField",
        "name": "employeeCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Employee",
            "kind": "LinkedField",
            "name": "employee",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAdminMainComponentEmployeeCreateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserAdminMainComponentEmployeeCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d0ca75a7ac37fa558e9a14bc1fb324eb",
    "id": null,
    "metadata": {},
    "name": "UserAdminMainComponentEmployeeCreateMutation",
    "operationKind": "mutation",
    "text": "mutation UserAdminMainComponentEmployeeCreateMutation(\n  $storeId: ID\n  $input: EmployeeCreateInput!\n) {\n  store(id: $storeId) {\n    employeeCreate(input: $input) {\n      employee {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "16117ec613ee952304bcbd880e383f9c";

export default node;
